import { wrap } from '~/styled-system/patterns'
import type { SubItem } from './data/type'
import { useItemsByDeviceType } from './useItemsByDeviceType'

const className = wrap({
  gap: '2',
  color: 'link',
  fontSize: 'sm',
  '& > li': {
    display: 'inline-flex',
    gap: '2',
    _notLast: { _after: { content: '"|"', color: 'gray.400' } },
  },
})

// FIXME: unify with apps/web/src/features/internalLinks/FooterInternalLinks.tsx:Links
export function Links({ items }: { items: SubItem[] }) {
  const filteredItems = useItemsByDeviceType(items)
  return (
    <ul className={className}>
      {filteredItems.map((item) => (
        <li key={item.label}>
          <a href={item.href}>{item.label}</a>
        </li>
      ))}
    </ul>
  )
}
